module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/flow_arrow_recruit-fcab1cd0bffac519172defdac4ba67ac.svg";